var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var debug = require('debug');

var _require = require('limiter'),
    RateLimiter = _require.RateLimiter;

var JwksRateLimitError = require('../errors/JwksRateLimitError');

function rateLimtWrapper(client, _ref) {
  var _ref$jwksRequestsPerM = _ref.jwksRequestsPerMinute,
      jwksRequestsPerMinute = _ref$jwksRequestsPerM === void 0 ? 10 : _ref$jwksRequestsPerM;
  var logger = debug('jwks');
  var getSigningKey = client.getSigningKey.bind(client);
  var limiter = new RateLimiter(jwksRequestsPerMinute, 'minute', true);
  logger("Configured rate limiting to JWKS endpoint at ".concat(jwksRequestsPerMinute, "/minute"));
  return function _callee2(kid) {
    return _regeneratorRuntime.async(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              limiter.removeTokens(1, function _callee(err, remaining) {
                var key;
                return _regeneratorRuntime.async(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (err) {
                          reject(err);
                        }

                        logger('Requests to the JWKS endpoint available for the next minute:', remaining);

                        if (!(remaining < 0)) {
                          _context.next = 7;
                          break;
                        }

                        logger('Too many requests to the JWKS endpoint');
                        reject(new JwksRateLimitError('Too many requests to the JWKS endpoint'));
                        _context.next = 17;
                        break;

                      case 7:
                        _context.prev = 7;
                        _context.next = 10;
                        return _regeneratorRuntime.awrap(getSigningKey(kid));

                      case 10:
                        key = _context.sent;
                        resolve(key);
                        _context.next = 17;
                        break;

                      case 14:
                        _context.prev = 14;
                        _context.t0 = _context["catch"](7);
                        reject(_context.t0);

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, null, null, [[7, 14]]);
              });
            }));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
}

module.exports.default = rateLimtWrapper;